import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

export const ASquarePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'var(--color-primary-50)',
      100: 'var(--color-primary-100)',
      200: 'var(--color-primary-200)',
      300: 'var(--color-primary-300)',
      400: 'var(--color-primary-400)',
      500: 'var(--color-primary-500)',
      600: 'var(--color-primary-600)',
      700: 'var(--color-primary-700)',
      800: 'var(--color-primary-800)',
      900: 'var(--color-primary-900)',
      950: 'var(--color-primary-950)',
    },
    colorScheme: {
      light: {
        surface: {
          0: 'var(--color-white)',
          50: 'var(--color-neutral-50)',
          100: 'var(--color-neutral-100)',
          200: 'var(--color-neutral-200)',
          300: 'var(--color-neutral-300)',
          400: 'var(--color-neutral-400)',
          500: 'var(--color-neutral-500)',
          600: 'var(--color-neutral-600)',
          700: 'var(--color-neutral-700)',
          800: 'var(--color-neutral-800)',
          900: 'var(--color-neutral-900)',
          950: 'var(--color-neutral-950)',
        },
      },
      dark: {
        surface: {
          0: 'var(--color-neutral-950)',
          50: 'var(--color-neutral-900)',
          100: 'var(--color-neutral-800)',
          200: 'var(--color-neutral-700)',
          300: 'var(--color-neutral-600)',
          400: 'var(--color-neutral-500)',
          500: 'var(--color-neutral-400)',
          600: 'var(--color-neutral-300)',
          700: 'var(--color-neutral-200)',
          800: 'var(--color-neutral-100)',
          900: 'var(--color-neutral-50)',
          950: 'var(--color-white)',
        },
      },
    },
  },
});

